import { createContext } from 'react';
import { FundByMeasurementDate } from 'common/types/store';
import { GenerateReportRequestData } from 'layouts/Main/components/ExcelExportDialog/types';

export interface ExcelExportContextType {
  doReportPollCheck: boolean;
  reportRequestData: GenerateReportRequestData | null;
  reportUUID: string | null;
  currentSelectedValues: Record<string, any>;
  setCurrentSelectedValues: (values: Record<string, any>) => void;
  setDoReportPollCheck: (value: boolean) => void;
  setReportRequestData: (data: GenerateReportRequestData | null) => void;
  setReportUUID: (uuid: string | null) => void;
  fundsByMeasurementDate: FundByMeasurementDate[];
  setFundsByMeasurementDate: (funds: FundByMeasurementDate[]) => void;
  isLoading: boolean;
}

const ExcelExportContext = createContext<ExcelExportContextType>({
  doReportPollCheck: false,
  reportRequestData: null,
  reportUUID: null,
  currentSelectedValues: {},
  setCurrentSelectedValues: () => {},
  setDoReportPollCheck: () => {},
  setReportRequestData: () => {},
  setReportUUID: () => {},
  fundsByMeasurementDate: [],
  setFundsByMeasurementDate: () => {},
  isLoading: false,
});

ExcelExportContext.displayName = 'ExcelExportContext';

export default ExcelExportContext;
